import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { formatISO } from "date-fns";
import {
  Account_Status,
  Asset_Status,
  CalculationBalance,
  SelectedAccount,
  SelectedAsset,
  UserDetails,
  getCalculationBalance,
  selectAsset,
  storeRiskLevel1,
  storeRiskLevel2,
  storeRiskLevel3,
} from "../../redux/userSlice";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderModal from "../ModalLoader/LoaderModal";

const SelectedAssetsComponent = ({ AccountStatus }) => {
  
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const dispatch = useDispatch();
  const userDetails = useSelector(UserDetails);
  const selectedAccountDetails = useSelector(SelectedAccount);
  const AssetStatus = useSelector(Asset_Status);

  const [assetid,setAssetid]=useState(1);

  const selectedAssetDetails = useSelector(SelectedAsset);

  const [clBalance, setClBalance] = useState([]);

  const [assets, setAssets] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const token = userDetails?.token;

  useEffect(() => {
    showAssets();
  }, []);

  const [assetList, setAssetlist] = useState();


  const Asset_inputs = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/AssetList/get-Asset-inputs-by-assetlistid/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("asset inputs data", response.data.response);
      setAssetlist(response.data.response);
      const assetData = response.data.response;
      if (id === 1 || id === 3 || id === 5 || id === 7) {
        onSubmit(id, assetData, "Asset_Calculation_For_CL_ES_NQ_YM");
      } else {
        onSubmit(id, assetData, "Asset_Calculation_For_MCL_MES_MYM_MNQ");
      }
      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };

  // console.log("asset list",assetList)

  //  asset list data get
  const showAssets = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/AssetList/get-all-Asset-List`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

  const First_asset=response.data.response[0];

      setAssets(response.data.response);
      dispatch(
        selectAsset({
          asset: {
            assetId: First_asset.assetId,
            assetName: First_asset.assetName,
          },
        })
      );
     
      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };

  // const today = new Date();
  // const createdDate = formatISO(today);

  // modal open function
  const handleCLick = (id, name) => {
    // if (id === 1||id ===2||id ===3||id ===4) {
    dispatch(
      selectAsset({
        asset: {
          assetId: id,
          assetName: name,
        },
      })
    );
    Asset_inputs(id);
    // onSubmit(id);
    // }
    // handleModal();
  };

  //selcted account id wise page reload


  // this is all asset wise input data

  // this is use for risk level data fetch in redux store
  const CalculationResponse = useSelector(CalculationBalance);
  // console.log("selectedAccountDetails.accountName",selectedAccountDetails.accountId)

  const navigate = useNavigate();
 




// RiskLevelCalculation/Risk-Level1-Calculation api called
const onSubmit_RiskLevelCalculation = async (assetid, responseAssetdata, apiEndPoint,risk_level_data) => {
 
  const initialValues = {
    pointValue: responseAssetdata ? responseAssetdata.pointValue : "",
    accountId: selectedAccountDetails?.accountId,
    tickSize: responseAssetdata ? responseAssetdata.tickSize : "",
    rtComms: responseAssetdata ? responseAssetdata.rtComms : "",
    trailStop1: responseAssetdata ? responseAssetdata.trailStop1 : "",
    trailStop2: responseAssetdata ? responseAssetdata.trailStop2 : "",
    be: responseAssetdata ? responseAssetdata.be : "",
    tP1: responseAssetdata ? responseAssetdata.tP1 : "",
    tP2: responseAssetdata ? responseAssetdata.tP2 : "",
    tP3: responseAssetdata ? responseAssetdata.tP3 : "",
    tP4: responseAssetdata ? responseAssetdata.tP4 : "",
  };
  // console.log("assetid on response",initialValues)
 
  const data = {
    ...initialValues,
    userId: userDetails.id,
    assetId: assetid,
    riskLevel1: risk_level_data
      ? parseFloat(risk_level_data?.aggressiveDRPT)
      : "",
    riskLevel2: risk_level_data
      ? parseFloat(risk_level_data?.neutralDRPT)
      : "",
    riskLevel3: risk_level_data
      ? parseFloat(risk_level_data?.conservativeDRPT)
      : "",
  };
 

 
  const stringData = {};

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      // console.log("data[key].toString();", data[key].toString());
      stringData[key] = data[key].toString();
    }
  }

  const from_Data = JSON.stringify(stringData);
 
  try {
    const response = await axios.post(
      `${APi_Url}api/RiskLevelCalculation/${apiEndPoint}`,
      from_Data,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // console.log("resonse onSubmit_RiskLevelCalculation",response)

    if (response.data.statusCode === 200) {
      
      // toast.success(response.data.response);
      
      // window.location.href = '/account2';
      get_RiskLevel1(assetid);
      get_RiskLevel2(assetid);
      get_RiskLevel3(assetid);
      // navigate('/account2', { replace: true })
      // UseRiskLevel1(assetid);

    }
  } catch (error) {
    console.error("Error ", error);
   
  }
};








  // RiskLevelCalculation/Risk-Level1-Calculation api called
  const onSubmit = async (assetid, responseAssetdata, apiEndPoint) => {
    const initialValues = {
      pointValue: responseAssetdata ? responseAssetdata.pointValue : "",
      accountId: selectedAccountDetails?.accountId,
      tickSize: responseAssetdata ? responseAssetdata.tickSize : "",
      rtComms: responseAssetdata ? responseAssetdata.rtComms : "",
      trailStop1: responseAssetdata ? responseAssetdata.trailStop1 : "",
      trailStop2: responseAssetdata ? responseAssetdata.trailStop2 : "",
      be: responseAssetdata ? responseAssetdata.be : "",
      tP1: responseAssetdata ? responseAssetdata.tP1 : "",
      tP2: responseAssetdata ? responseAssetdata.tP2 : "",
      tP3: responseAssetdata ? responseAssetdata.tP3 : "",
      tP4: responseAssetdata ? responseAssetdata.tP4 : "",
    };
    // console.log("assetid on response",initialValues)
    setShowModal(true);
    const data = {
      ...initialValues,
      userId: userDetails.id,
      assetId: assetid,
      riskLevel1: CalculationResponse
        ? parseFloat(CalculationResponse?.aggressiveDRPT)
        : "",
      riskLevel2: CalculationResponse
        ? parseFloat(CalculationResponse?.neutralDRPT)
        : "",
      riskLevel3: CalculationResponse
        ? parseFloat(CalculationResponse?.conservativeDRPT)
        : "",
    };
    console.log("Asset Inputs data",data)

   
    const stringData = {};

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // console.log("data[key].toString();", data[key].toString());
        stringData[key] = data[key].toString();
      }
    }

    const from_Data = JSON.stringify(stringData);
   
    try {
      const response = await axios.post(
        `${APi_Url}api/RiskLevelCalculation/${apiEndPoint}`,
        from_Data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      

      if (response.data.statusCode === 200) {
        
        toast.success(response.data.response);
      
        
        // window.location.href = '/account2';
        get_RiskLevel1(assetid);
        get_RiskLevel2(assetid);
        get_RiskLevel3(assetid);
        // navigate('/account2', { replace: true })
        

      }
      setShowModal(false);
    } catch (error) {
      console.error("Error ", error);
      setShowModal(false);
    }
  };
  // Risk level 1
  const get_RiskLevel1 = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-1/${userDetails.id}/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setShowModal(false);
      dispatch(storeRiskLevel1(response.data.response));
      // setRisk_Level1(response.data.response);

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };
  // Risk level 2
  const get_RiskLevel2 = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-2/${userDetails.id}/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(storeRiskLevel2(response.data.response));

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };
  // Risk Level 3
  const get_RiskLevel3 = async (id) => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-3/${userDetails.id}/${id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(storeRiskLevel3(response.data.response));

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };
// this is for account change
const Asset_inputs1 = async (id,risk_level_data) => {
  
  try {
    const response = await axios.get(
      `${APi_Url}api/AssetList/get-Asset-inputs-by-assetlistid/${id}`,

      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setShowModal(false);
    
    const assetData = response.data.response;
    if (id === 1 || id === 3 || id === 5 || id === 7) {
      onSubmit_RiskLevelCalculation(id, assetData, "Asset_Calculation_For_CL_ES_NQ_YM",risk_level_data);
    } else {
      onSubmit_RiskLevelCalculation(id, assetData, "Asset_Calculation_For_MCL_MES_MYM_MNQ",risk_level_data);
    }
    // Handle response data as needed
  } catch (error) {
    // console.error("Error ", error);
  }
};

  useEffect(() => {
    showRiskLevelCalculation();
  
  }, [selectedAccountDetails?.accountId]);

  // selcted account id wise get risk level calculation
  const showRiskLevelCalculation = async () => {
    
  setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-List/${userDetails.id}/${selectedAccountDetails?.accountId}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("response get-all-risk-level", response?.data);

      // if selected isd wise calculated data then store is redux store
      if (response?.data?.response[0]) {
       
        const RISK_Leveldata=response?.data?.response[0];
       
        dispatch(getCalculationBalance(response.data.response[0]));
        // dispatch(getCalculationBalance("Assetcalculation"));
        setTimeout(() => Asset_inputs1(assetid, RISK_Leveldata), 100);
        
      } else {
        dispatch(getCalculationBalance(null));
        dispatch(storeRiskLevel1(null));
        dispatch(storeRiskLevel2(null));
        dispatch(storeRiskLevel3(null));
        // alert("hello")
        setShowModal(false);
      }

      // Handle response data as needed
    } catch (error) {
      console.error("get-all-risk-level Error ", error);
      setShowModal(false);
    }
  };

  // modal validation from submit end
  return (
    <div className="dropdown">
      <button
        className="btn dropdown-toggle form-select"
        type="button"
        disabled={!AccountStatus}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{minWidth:'100px'}}
      >
        {selectedAssetDetails ? selectedAssetDetails.assetName : "Select Asset"}
      </button>
      <ul className="dropdown-menu">
        {assets.map((asset) => (
          // className={asset.assetId !== 1&& asset.assetId !== 2 && asset.assetId !== 4 && asset.assetId !== 3 ? 'disabled' : ''
          <li key={asset.assetId}>
            {/* style={{ pointerEvents: asset.assetId !== 1&& asset.assetId !== 2 && asset.assetId !== 3 && asset.assetId !== 4 ? 'none' : 'auto' }} */}
            <Link
              className="dropdown-item"
              onClick={() => {
                handleCLick(asset.assetId, asset.assetName);
               
              }}
            >
              {asset.assetName}
            </Link>
          </li>
        ))}
      </ul>
      {/* for account modal */}

      {/* <div
        className={`modal fade inputmodal ${showModal ? "show" : ""}`}
        aria-hidden="true"
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        id="asset-modal"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1>MoneyManagement</h1>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
              >
                {({ isSubmitting, isValid, dirty }) => (
                  <Form className="row needs-validation">
                    <div className="col-12">
                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Point value
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="pointValue"
                                name="pointValue"
                                placeholder="Input here"
                                className="form-control"
                                onWheel={(e) => e.target.blur()}
                              />
                              <ErrorMessage
                                name="pointValue"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Tick size
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tickSize"
                                name="tickSize"
                                placeholder="Input here"
                                className="form-control"
                                onWheel={(e) => e.target.blur()}
                              />
                              <ErrorMessage
                                name="tickSize"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Rt Comms
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="rtComms"
                                name="rtComms"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="rtComms"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="row ">
                            <label className="col-4 col-form-label">
                              Trail Stop 1
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="trailStop1"
                                name="trailStop1"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="trailStop1"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Trail Stop 2
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="trailStop2"
                                name="trailStop2"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="trailStop2"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="row">
                            <label className="col-sm-4 col-form-label">
                              Be
                            </label>
                            <div className="col-sm-8">
                              <Field
                                type="number"
                                id="be"
                                name="be"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="be"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 1</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP1"
                                name="tP1"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP1"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 2</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP2"
                                name="tP2"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP2"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 3</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP3"
                                name="tP3"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP3"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 4</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP4"
                                name="tP4"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP4"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isValid}
                    <div className="col-12">
                      <button
                        className="btn kevlar_btn"
                        type="submit"
                        data-bs-dismiss={isValid ? "modal" : undefined}
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>

              <div className="row mb-3">
                <div className="col-12">
                  <button
                    className="btn kevlar_btn"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <LoaderModal show={showModal} />
    </div>
  );
};

export default SelectedAssetsComponent;
